var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-image"},[_c('SpriteClip',{staticClass:"preview-image__image__preview",attrs:{"image-url":_vm.previewImageUrl}}),_c('AppImage',{staticClass:"preview-image__image__picture",attrs:{"src":_vm.previewImageUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }